module.exports = __webpack_public_path__ + "static/media/29EUNOG18.1ee14426.jpg";